import { render } from "./OrderHistoryEntry.vue?vue&type=template&id=30fcf4d8"
import script from "./OrderHistoryEntry.vue?vue&type=script&lang=js"
export * from "./OrderHistoryEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__